import _ from 'lodash';
import moment from 'moment';

const hourlyTaskCount = 9;
const hourlyTaskMinuteBuffer = 15;

export default {
  async fetchHourlyTasks () {
    const firstCheckInData = (
      await axios.get('user-first-check-in')
    ).data.data;

    if (!firstCheckInData) return;

    const filters = {
      assigned_to: 'personal',
      type: 'hourly',
      range: 'today',
      status: 'today',
    };

    const hourlyData = (await this.fetchTasks(filters));

    let tasks = [];
    for (let i = 0; i < hourlyTaskCount; i++) {
      const hour = this.nextHour(firstCheckInData.timestamp, i);
      const taskItem = _.find(hourlyData, task =>
        this.timeIsSame(task.completed_at, hour),
      ) || {
        completed_at: hour,
        title: '',
        type: 'hourly',
      };
      tasks.push(taskItem);
    }
    return tasks;
  },

  async fetchTodoTasks (status, dateRange, page) {
    const start_date = moment().
      subtract(parseInt(dateRange), 'days').
      toDate();
    const end_date = moment().toDate();

    return (await axios.get('/tasks', {
      params: {
        type: 'todo',
        assigned_to: 'personal',
        statuses: status,
        page: page,
        start_date,
        end_date,
      },
    })).data;
  },

  async fetchTasks (filters) {
    return (await axios.get('/tasks', { params: filters })).data;
  },

  async fetchCompanyTasks (status, dateRange, page, teamId = null) {
    const start_date = moment().subtract(parseInt(dateRange), 'days').toDate();
    const end_date = moment().toDate();

    return (await axios.get('/tasks', {
      params: {
        type: 'todo',
        assigned_to: 'company',
        statuses: status,
        page: page,
        team_id: teamId,
        start_date,
        end_date,
      },
    })).data;
  },

  async fetchTeamTasks (status, dateRange, page, teamId = null) {
    const start_date = moment().subtract(parseInt(dateRange), 'days').toDate();
    const end_date = moment().toDate();

    return (await axios.get('/tasks', {
      params: {
        type: 'todo',
        assigned_to: 'team',
        statuses: status,
        page: page,
        team_id: teamId,
        start_date,
        end_date,
      },
    })).data;
  },

  async fetchUserGoals () {
    return (await axios.get('/get-user-goals?status=active')).data.data;
  },

  async fetchTeamGoals () {
    return (await axios.get('/get-team-goals?status=active')).data.data;
  },

  async fetchCompanyGoals () {
    return (await axios.get('/get-company-goals?status=active')).data.data;
  },

  nextHour (timeString, additionalHour = 0) {
    const time = moment.utc(timeString).local();
    const nexthour =
      time.minute() >= hourlyTaskMinuteBuffer
        ? time.add(2 + additionalHour, 'hours').startOf('hour')
        : time.add(1 + additionalHour, 'hours').startOf('hour');
    return nexthour.format();
  },

  timeIsSame (time1, time2) {
    return (
      moment(time1).format('MM:DD:HH:mm:ss') ===
      moment(time2).format('MM:DD:HH:mm:ss')
    );
  },

  hourlyTaskPlaceholder (time, timezone) {
    const momentTime = timezone
      ? moment.utc(time).tz(timezone)
      : moment.utc(time).local();

    const hour = momentTime.format('h:mm A');
    const date = momentTime.format('do MMMM');

    let text = `Task done at ${hour}`;

    const today = timezone
      ? moment.utc().tz(timezone)
      : moment.utc().local();

    if (!today.isSame(momentTime, 'day')) {
      text = `${text} on ${date}`;
    }

    return text;
  },
};
